import { createSelector } from 'reselect'

export const getProtracks = state => state.get('persist').protracks

export const getUnsavedChanges = createSelector(getProtracks, protracks => protracks.get('unsavedChanges'))

export const getBlockedPathName = createSelector(getUnsavedChanges, unsavedChanges =>
  unsavedChanges.get('blockedPathName')
)

export const getTouched = createSelector(getUnsavedChanges, unsavedChanges => unsavedChanges.get('touched'))

export const getTouchedLevels = createSelector(getTouched, touched => touched.get('levels'))

export const getTouchedActivities = createSelector(getTouched, touched => touched.get('activities'))
